import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import {
  navigationMemoryInitialState,
  navigationMemoryReducer,
} from './navigation-memory.reducer';
import { NavigationMemoryService } from './navigation-memory.service';
import {
  navigationMemoryFeatureKey,
  INavigationMemoryState,
} from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<INavigationMemoryState>(
      navigationMemoryFeatureKey,
      navigationMemoryReducer,
      {
        initialState: navigationMemoryInitialState,
      },
    ),
  ],
  providers: [NavigationMemoryService],
})
export class StoreNavigationMemoryModule {}
